import useLenis from "@/hooks/useLenis";
import CountdownBar from "@/components/CountdownBar";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Journey from "@/components/Journey";
import Activities from "@/components/Activities";
import Location from "@/components/Location";
import Sponsors from "@/components/Sponsors";
import RegistrationForm from "@/components/RegistrationForm";
import Footer from "@/components/Footer";

export default function LandingPage() {
  useLenis();
  return (
    <main className="relative" data-testid="landing-page">
      <Header />
      <Hero />
      <Marquee />
      <Journey />
      <Activities />
      <Location />
      <RegistrationForm />
      <Sponsors />
      <Footer />
    </main>
  );
}
